import {css} from 'lit';
export const styles = css`:host{display:contents}:host([src]) img,svg{display:inline;object-fit:cover}:host([hidden]){display:none}`;
export default styles;
